import { QuestionBannerInfoValueType } from '@/hooks/qna/useQuestionDetailViewModel';
import { CustomPageProps } from '@/types/app';

interface Props extends CustomPageProps {
  questionBannerInfo: QuestionBannerInfoValueType;
  onClick: () => void;
}
const QnaAdFallback = ({ questionBannerInfo, client, onClick }: Props) => {
  if (client.isWebView) {
    return null;
  }

  if (client.isMobile) {
    return (
      <div className='cursor-pointer px-[24px] pb-[40px]'>
        <div
          className={
            'relative flex aspect-[312/96] w-full flex-col justify-center rounded-[12px] bg-[#FFF9DB] pl-[24px]'
          }
          onClick={onClick}
        >
          <p className={'typography-ui-12m mb-[3px] text-gray-600'}>{questionBannerInfo.headText}</p>
          <div className={'typography-ui-17b flex flex-col text-primary-800'}>
            {questionBannerInfo.mainTextRows.map((text, index) => {
              return <span key={`mainText-${index}`}>{text}</span>;
            })}
          </div>
          <img
            className='absolute right-0 bottom-0 w-[90px] object-contain'
            src='/images/qna/bannerPhone.png'
            alt='banner_phone'
          />
        </div>
      </div>
    );
  }

  return (
    <div className='cursor-pointer overflow-hidden px-[24px] pt-[20px] pb-[40px]'>
      <div
        className={
          'relative flex aspect-[720/120] w-full flex-col justify-center rounded-[16px] bg-[#FFF9DB] px-[24px]'
        }
        onClick={onClick}
      >
        <p className={'typography-ui-17m mb-[4px] text-gray-600'}>{questionBannerInfo.headText}</p>
        <div className={'typography-ui-24b flex flex-col text-primary-800'}>
          {questionBannerInfo.mainTextRows.map((text, index) => {
            return <span key={`mainText-${index}`}>{text}</span>;
          })}
        </div>
        <img
          className='absolute right-[44px] bottom-0 w-[100px] object-contain'
          src='/images/qna/bannerPhone.png'
          alt='banner_phone'
        />
      </div>
    </div>
  );
};

export default QnaAdFallback;
